import { useEffect, useRef } from 'react'
import type { RefObject } from 'react'

import {
  LINKEDIN_CAPABILITIES_QUERY_PARAM,
  LINKEDIN_CAPABILITIES_SCROLL_HASH,
} from './config'

const prefersReducedMotion = (): boolean =>
  window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false

const useScrollToLinkedInCapabilitiesSection = (
  sectionRef: RefObject<HTMLDivElement>,
): void => {
  const hasScrolledToSectionRef = useRef(false)

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    const shouldScrollToSection =
      window.location.hash === `#${LINKEDIN_CAPABILITIES_SCROLL_HASH}` ||
      searchParams.get(LINKEDIN_CAPABILITIES_QUERY_PARAM) === 'true'

    if (!shouldScrollToSection || hasScrolledToSectionRef.current) {
      return
    }

    hasScrolledToSectionRef.current = true
    sectionRef.current?.scrollIntoView({
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      block: 'center',
    })
  }, [sectionRef])
}

export { useScrollToLinkedInCapabilitiesSection }
